import { useEffect, useState } from "react";

const useKeyboardAvoidance = () => {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const adjustForKeyboard = () => {
      const viewport = window.visualViewport;
      if (viewport.height < window.innerHeight) {
        setOffset(window.innerHeight - viewport.height);
      } else {
        setOffset(0);
      }
    };

    window.visualViewport.addEventListener("resize", adjustForKeyboard);
    return () =>
      window.visualViewport.removeEventListener("resize", adjustForKeyboard);
  }, []);

  return offset;
};
export default useKeyboardAvoidance;
